import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons

// core components
import styles from "core/assets/jss/material-dashboard-pro-react/components/cardStyle.js";

const useStyles = makeStyles(styles);

export default function Card(props) {
  const classes = useStyles();
  const {
    className,
    children,
    container,
    plain,
    profile,
    centered,
    blog,
    raised,
    background,
    pricing,
    color,
    product,
    none,
    nomargin,
    minmargin,
    removed,
    accepted,
    rejected,
    clarification,
    testimonial,
    outlineColor,
    chart,
    login,
    ...rest
  } = props;
  const cardClasses = classNames({
    [classes.card]: true,
    [classes.cardContainer]: container,
    [classes.cardPlain]: plain,
    [classes.cardCentered]: centered,
    [classes.cardProfile]: profile || testimonial,
    [classes.cardBlog]: blog,
    [classes.cardRaised]: raised,
    [classes.cardBackground]: background,
    [classes.cardPricingColor]:
      (pricing && color !== undefined) || (pricing && background !== undefined),
    [classes[color]]: color,
    [classes["cardOutline" + outlineColor]]: outlineColor,
    [classes.cardPricing]: pricing,
    [classes.cardProduct]: product,
    [classes.cardAccepted]: accepted,
    [classes.cardRejected]: rejected,
    [classes.cardClarification]: clarification,
    [classes.cardNone]: none,
    [classes.cardRemoved]: removed,
    [classes.cardChart]: chart,
    [classes.cardLogin]: login,
    [classes.cardNoMargin]: nomargin,
    [classes.cardMinMargin]: minmargin,
    [className]: className !== undefined
  });
  return (
    <div className={cardClasses} {...rest}>
      {children}
    </div>
  );
}

Card.propTypes = {
  className: PropTypes.string,
  plain: PropTypes.bool,
  profile: PropTypes.bool,
  centered: PropTypes.bool,
  blog: PropTypes.bool,
  raised: PropTypes.bool,
  background: PropTypes.bool,
  pricing: PropTypes.bool,
  container: PropTypes.bool,
  testimonial: PropTypes.bool,
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "green",
    "warning",
    "orange",
    "danger",
    "red",
    "rose",
    "gray",
    "lightgray",
    "darkgray",
    "black",
    "blue",
    "none"
  ]),
  outlineColor: PropTypes.oneOf([
    "None",
    "Black",
    "Gray",
    "Blue",
    "Gold"
  ]),
  none: PropTypes.any,
  product: PropTypes.bool,
  chart: PropTypes.bool,
  login: PropTypes.bool,
  children: PropTypes.node
};
